/*
 * Part of the RubinRed CMS.
 * @author    Paolo Pontarollo <pontarollo@workup.it>
 * @license   Proprietary
 * @copyright 2015-2018, Workup Srl
 * @link      http://rubinred.com
 */

export default class LaravelFormatter {
  constructor(options = {}) {
  }

  /**
   * @param {String} message
   * @param {Object} values
   * @returns {Array}
   */
  interpolate(message, values) {
    if(! values) {
      return [message];
    }

    //TODO: handle i18n functional component

    values = this.prepareValues(values);

    for (let key in values) {
      message = message.replace(':'+key, values[key]);
    }

    return [message];
  }

  prepareValues(values) {
    let ordered = {};
    Object.keys(values).sort((a,b) => b.length - a.length).forEach(key => {
      ordered[key] = values[key];
    });

    return ordered;
  }
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/utils/LaravelFormatter.js